import { AxiosError } from 'axios';
import { CommandResult, FormApiService, ItemCommandResult, QueryApiService } from 'src/common/api-service';
import { Experience } from '../person-profile/types';
import { EnterprisePublicSimulationInfo, VacanciesInfo, VacanciesRequest } from './types';

export interface PublicEnterpriseSimulatorInput {
  name: string;
  email: string;
  jobs2LiveJobRoleId: string;
  experience: Experience;
  daysToFindRole: number;
  origin?: string;
  isTest?: boolean;
}

export class PublicEnterpriseSimulatorApiService extends FormApiService {
  constructor() {
    super('publicEnterpriseSimulator');
  }

  public async requestAccess(body: PublicEnterpriseSimulatorInput): Promise<CommandResult> {
    try {
      return await this.post<PublicEnterpriseSimulatorInput, CommandResult>(body, 'requestAccess');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async visit(id: string): Promise<CommandResult> {
    try {
      return await this.put<any, CommandResult>({}, `${encodeURIComponent(id)}/visit`);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performLastSimulation(accessId: string): Promise<ItemCommandResult<EnterprisePublicSimulationInfo>> {
    try {
      return await this.post<null, ItemCommandResult<EnterprisePublicSimulationInfo>>(
        null as any,
        `repeatLastSimulation/${encodeURIComponent(accessId)}`
      );
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<EnterprisePublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performSimulation(accessId: string, body: PublicEnterpriseSimulatorInput): Promise<ItemCommandResult<EnterprisePublicSimulationInfo>> {
    try {
      return await this.post<PublicEnterpriseSimulatorInput, ItemCommandResult<EnterprisePublicSimulationInfo>>(
        body,
        `performSimulation/${encodeURIComponent(accessId)}`
      );
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<EnterprisePublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performRandomSimulation(): Promise<ItemCommandResult<EnterprisePublicSimulationInfo>> {
    try {
      return await this.post<null, ItemCommandResult<EnterprisePublicSimulationInfo>>(null, `performRandomSimulation`);
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<EnterprisePublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async getAvailableVacancies(accessId: string, body: VacanciesRequest): Promise<ItemCommandResult<VacanciesInfo>> {
    try {
      return await this.post<VacanciesRequest, ItemCommandResult<VacanciesInfo>>(body, `vacancies/${encodeURIComponent(accessId)}`);
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<VacanciesInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async getRandomAvailableVacancies(body: VacanciesRequest): Promise<ItemCommandResult<VacanciesInfo>> {
    try {
      return await this.post<VacanciesRequest, ItemCommandResult<VacanciesInfo>>(body, 'randomVacancies');
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<VacanciesInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}

export class PublicEnterpriseSimulatorQueryApiService extends QueryApiService<any> {
  constructor() {
    super('publicEnterpriseSimulator');
  }
}
